import React, { useState } from 'react';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import MapPopup from './MapPopup';
import Mission from '../../models/missions/mission';
import MissionScaledImage from './MissionScaledImage';

const MissionMap: React.FC<{ mission: Mission }> = ({ mission }) => {
  const [isMapPopupOpen, setIsMapPopupOpen] = useState(false);

  const openMapPopupClickHandler = () => {
    setIsMapPopupOpen(true);
  };

  const closeMapPopupHandler = () => {
    setIsMapPopupOpen(false);
  };

  return (
    <React.Fragment>
      <Grid item xs={12} md={6}>
        <CardActionArea onClick={openMapPopupClickHandler}>
          <MissionScaledImage mission={mission} />
        </CardActionArea>
      </Grid>
      {isMapPopupOpen && (
        <MapPopup open={isMapPopupOpen} onClose={closeMapPopupHandler} cleaningImage={mission} />
      )}
    </React.Fragment>
  );
};

export default MissionMap;
